import React, { useEffect, useState } from 'react';
import { makeApiRequest } from '../axiosService/apiCall';
import DataTable from 'react-data-table-component';
import config from "./config"

function AdminmanualTransferHistory() {
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const userData = async () => {
        try {
            let params = {
                url: `userstakedetails`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log('userstakedetails', response)
            if (response.status === true) {
                setData(response.Findstakedetails);
            } else {
                setData([]);
            }
        } catch (error) {
            // console.log('error', error);
        }
    };

    useEffect(() => {
        userData();
    }, []);

    const compressString = (str) => {
        return str.length > 10 ? `${str.slice(0, 6)}...${str.slice(-4)}` : str;
    };
    const formatISTDate = (dateString) => {

        if (!dateString) return "-";


        const date = new Date(dateString);

        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const columns = [
        { name: 'S.No', width: '100px', selector: (row) => row.sno },
        {
            name: 'StartDate',
            width: '200px',
            selector: row => row.startdate ? formatISTDate(row.startdate) : "-",
            cell: (row) => <div className="no-wrap-cell">{row.startdate ? formatISTDate(row.startdate) : "-"}</div>,
        },
        {
            name: 'EndDate',
            width: "200px",
            selector: (row) => row.enddate ? formatISTDate(row.enddate) : "-",
            cell: (row) => <div className="no-wrap-cell">{formatISTDate(row.enddate)}</div>,
        },
        {
            name: 'Email',
            width: '300px',
            selector: (row) => row.email,
            cell: (row) => <div className="no-wrap-cell">{row.email}</div>,
        },
        {
            name: 'Amount',
            width: '100px',
            selector: (row) => row.amount,
            cell: (row) => <div className="no-wrap-cell">{row.amount}</div>,
        },
        {
            name: 'plan',
            width: '100px',
            selector: (row) => row.plan,
            cell: (row) => <div className="no-wrap-cell">{row.plan}</div>,
        },
        {
            name: 'Rate(Yearly)',
            width: '150px',
            selector: (row) => row.rate,
            cell: (row) => <div className="no-wrap-cell">{row.rate}</div>,
        },
        {
            name: 'Earning Rewards',
            width: '150px',
            selector: (row) => row.rewardsEarned
            ,
            cell: (row) => <div className="no-wrap-cell">{row.rewardsEarned
            }</div>,
        },
        {
            name: 'Status',
            width: '100px',
            selector: (row) => row.status,
            cell: (row) => <div className="no-wrap-cell">{row.status}</div>,
        },
    ];

    const formattedData = data && Array.isArray(data) ? data.map((row, index) => ({

        sno: index + 1,
        _id: row._id,
        email: row.email ? row.email : "-",
        startdate: row.startDate ? row.startDate : "-",
        enddate: row.endDate ? row.endDate : "-",
        plan: row.plan.period ? row.plan.period : "-",
        rate: row.plan.rate ? row.plan.rate : "-",
        status: row.status == 1 ? "Active" : "Completed",
        amount: row.amount ? row.amount : "-",
        rewardsEarned: row.rewardsEarned !== undefined ? row.rewardsEarned : "-",


    })) : [];

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setResetPaginationToggle(!resetPaginationToggle); // Reset pagination toggle
    };

    const filteredData = formattedData
        .filter(item => {
            const searchLower = searchTerm.toLowerCase();

           
            const formattedStartDate = item.startdate ? formatISTDate(item.startdate).toLowerCase() : "";
            const formattedEndDate = item.enddate ? formatISTDate(item.enddate).toLowerCase() : "";

            return (
                item.email.toLowerCase().includes(searchLower) ||  
                formattedStartDate.includes(searchLower) ||        
                formattedEndDate.includes(searchLower)             
            );
        })
        .map((item, index) => ({
            ...item,
            sno: index + 1
        }));
    return (
        <div className='App'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className="custom-saled-order text-dark ms-3">
                            <div className="py-3 d-flex justify-content-between">
                                <h3 className="component-user">User Stake Details</h3>
                            </div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="Search by Email or Date"
                                    // style={{ "margin": "25px" }}
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    className='form-search mb-4'
                                /> <br />
                                <div className='custom-datascroll'>
                                    <DataTable
                                        className="text-center "
                                        columns={columns}
                                        data={filteredData}
                                        pagination
                                        persistTableHead
                                        // sortFunction={customSort}
                                        paginationPerPage={5}
                                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminmanualTransferHistory